import type { SessionMentor } from '../../../types/mentor';

interface StartProps {
  companionData: SessionMentor;
}

export const CompanionInfo: React.FC<StartProps> = ({ companionData }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-3 h-[41vh] px-8 py-8 text-white bg-black/50 lg:px-10 lg:py-10 lg:flex lg:gap-4">
      <div className="lg:flex overflow-auto h-full w-full">
        <div className="relative lg:w-3/5">
          <div className="text-3xl font-bold leading-[120%] capitalize font-[DM_Serif_Text] md:text-5xl lg:text-6xl">
            {`${companionData.firstName} ${companionData.lastName}`}
          </div>
          <div className="mt-[15px] mb-[10px] text-xl font-medium leading-[150%] max-w-[500px] md:block">
            {companionData.call_to_action || companionData.headline}
          </div>
        </div>
        <p className="relative text-lg font-light leading-[1.3] lg:w-2/5">
          {companionData.summary}
        </p>
      </div>
    </div>
  );
};
